import React from 'react';
import { Input, Select, Button, Loadable, FieldSet, FormGroup, Validator as V } from 'hrone-react';
import { observer } from 'mobx-react';
import './index.less';
import mainStore from '../main.store';
import store from './index.store';

@observer
export default class Login extends React.Component {
    componentDidMount() {
        store.clearValidation();
    }
    componentWillUnmount() {
        store.clearStore();
    }

    saveLoading = (node: Loadable): void => {
        store.loadingCom = node;
    };

    onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          store.submit();
        }
      }

    render() {
        return (
            <div className='login-form'>
                <V.Form className='login-form-wrapper' store={store}>
                    <div className='login-form-label'>
                        <FieldSet className='login-form-fieldSet' size='large' cols={1}>
                            <FormGroup
                                className='phone-group'
                                title={store.isForeignPhone ? '国际手机号' : '用户名/手机号'}
                                layout='vertical'>
                                <Choose>
                                    <When condition={store.isForeignPhone}>
                                        <div>
                                            <V.Select
                                                className='phone-select'
                                                field='loginForm.areaCode'
                                                options={store.areaCodeOptions}
                                                autoSelect={true}
                                                allowEmpty={false}
                                                tetherable={true}
                                            />
                                            <V.Input field='loginForm.loginName' className='foreign-phone-input' />
                                        </div>
                                    </When>
                                    <Otherwise>
                                        <V.Input field='loginForm.loginName' className='phone-input' />
                                    </Otherwise>
                                </Choose>
                            </FormGroup>
                            <FormGroup title='密码'>
                                <V.Password field='loginForm.password' onKeyDown={this.onKeyDown}/>
                            </FormGroup>
                        </FieldSet>
                    </div>
                    <div className='password-register-button'>
                        <div onClick={mainStore.toResetPassword}>忘记密码</div>
                        <div onClick={mainStore.toRegister}>注册</div>
                    </div>
                    <Loadable ref={this.saveLoading}>
                        <div className='login-form-button'
                            onClick={store.submit}>登录
                        </div>
                    </Loadable>

                    <If condition={store.isForeignPhone}>
                        <div className='back' onClick={store.toLoginWithForeignCell}>
                            返回
                        </div>
                    </If>
                </V.Form>
                <If condition={!store.isForeignPhone}>
                    <div className='other-login-method'>
                        <div>其它方式登录：</div>
                        <div className='foreign-phone' onClick={store.toLoginWithForeignCell}>
                            国际手机号
                        </div>
                    </div>
                </If>
                <div className="recordNo">
                    <span>Copyright 2010-2019GaiaWorks Corporation，All Rights Reserved 盖雅工场版权所有 | </span><a href='http://www.miitbeian.gov.cn'>苏ICP备12047504号-3</a>
                </div>
            </div>
        );
    }
}
